export enum TrackTracerItemActionsEnum {
  InviteCompanion = "InviteCompanion",
  EnrollChildren = "EnrollChildren",
  BuySalaryEnsurance = "BuySalaryEnsurance",
  BuyUnemploymentInsurance = "BuyUnemploymentInsurance",
  BuyUnion = "BuyUnion",
  None = "None",
}
